export default __webpack_public_path__ + "static/media/7.f4fb3600.jpg";